import i18n from '@/lang/i18n'

export default {
    title: i18n.t('configuration.elementTitle.notificationsAlarms'),
    id: 'laboratoryNotifications',
    sidebar: [
        // TODO: Front debe echarle un vistazo para ver si se puede hacer mejor
        {
            id: 'notifications',
            label: i18n.tc('configuration.sections.notificationType', 2),
            icon: 'fal fa-envelope',
            routeName: 'LocalNotificationTypes',
            active: true
        },
        {
            id: 'alarms',
            label: i18n.tc('configuration.sections.alarm', 2),
            icon: 'fal fa-bell',
            routeName: 'Alarms',
            active: true
        },
        {
            id: 'customNotifications',
            label: i18n.tc('configuration.sections.customNotification', 2),
            icon: 'fal fa-mail-bulk',
            routeName: 'CustomNotification',
            active: true,
            hasChildren: true,
            children: [
                {
                    id: 'templates',
                    label: i18n.tc('configuration.sections.template', 2),
                    routeName: 'CustomNotificationTemplates'
                },
                {
                    id: 'predefinedNotifications',
                    label: i18n.tc('configuration.sections.predefinedNotification', 2),
                    routeName: 'CustomNotificationPredefined'
                }
            ]
        }
    ]
}
